












import Vue from "vue";
import BasicCardTemplate from "./BasicCardTemplate.vue";

export default Vue.extend({
  name: "NoUpcomingEventsCard",
  methods: {
    redirectToCalendar() {
      this.$router.push("/calendar");
    }
  }
});
